
import {
    ref,
    // computed
} from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import {log} from "@/composables/useLog";
import useLoginWithToken from "@/composables/useLoginWithToken";
const user = ref(null)
const loggedIn = ref(false)
const userAvatar = ref(null)
const token = ref(null)

const getLoggedIn= async ()=> {
    const store = useStore()
    const router=useRouter()
    log("router!!!!!!!!!!!!!!!!!!!!!!!!")
    log(router)
    log("router!!!!!!!!!!!!!!!!!!!!!!!!")
    if(router) {
        // const route = router.currentRoute.value.name
        log("welcome in getLoggedIn din useGetLoggedIn din ....route=" )
    }
    user.value = store.getters.getUser
    log("citim user din store si primim:")
    log(user.value)
        log("am citit user in getLoggedIn cu valorile:")
        if(user.value) {
            log("am gasit in getLoggedIn user in store cu value:"+user.value.id)
            log(user.value)
            userAvatar.value=user.value.avatar
            loggedIn.value=store.getters.getLoggedIn
            token.value=store.getters.getToken
            log("in getloggedIn am primit rezultatele:")
            if(loggedIn.value) log("loggedIn.value:"+loggedIn.value)
            if(token.value) log("token.value:"+token.value)
            if(userAvatar.value) log("userAvatar.value:"+userAvatar.value)
            // log("gata suntem logati in getLoggedIn din "+route)
            log("gata suntem logati in getLoggedIn din ")
        }
        if (loggedIn.value !=true){
            log("\n\n\n ------------------------- \n\n nu am gasit loggedIn.value ==true in getLoggedIn, cautam token in localStorage")
            const {loginWithToken}=useLoginWithToken()
            let storedToken=localStorage.getItem('token')
            if(storedToken){
                log("am gasit token in localstorage ")
                log(storedToken)
                log(1)
                let result= await loginWithToken(storedToken)
                log(2)
                log("welcome back from loginWithToken(token)")
                log(3)
                log(result)
                if (result.error == true) {
                    log(4)
                    router.replace({name:"homeLoggedOut"})
                } else {
                    log(5)
                    log("s.a logat ok in loginWithToken, scriem datele in vuex si ne ducem in pagina principala")
                    user.value = result.user
                    loggedIn.value = result.loggedIn
                    token.value=storedToken
                    log(user.value)
                    store.commit('setToken',{token:storedToken})
                }

            }else{
                log('nu am gasit nimic in localstorage')
                router.replace({name:"homeLoggedOut"})
            }
        }

}



const getDelay = async (ms) => new Promise(res => setTimeout(res, ms));

const useGetLoggedIn= ()=>{
    return {getLoggedIn, user, loggedIn, userAvatar,token, getDelay}
}

export  default  useGetLoggedIn
